/**
 * 環境変数の取得
 *
 * Create React App の `REACT_APP_*` はビルド時にバンドルへ文字列として焼き込まれるため、
 * そのままではコンテナ起動時の環境変数を反映できない。
 * 本番イメージでは起動時に `env.js` が生成されて `window.RUNTIME_ENV` に値が入るので、
 * そちらを優先し、無ければビルド時の値（ローカル開発の `.env`）にフォールバックする。
 *
 * ビルド時の値は webpack が静的に置換するため、キーを動的に組み立てられない。
 * 新しい環境変数を追加する場合はここにも追記すること。
 */
const buildTimeEnv = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_MASTER_API_URL: process.env.REACT_APP_MASTER_API_URL,
  REACT_APP_USER_API_URL: process.env.REACT_APP_USER_API_URL,
  REACT_APP_USER_PAGE_URL: process.env.REACT_APP_USER_PAGE_URL,
  REACT_APP_USER_CSV_TEMPLATE_URL: process.env.REACT_APP_USER_CSV_TEMPLATE_URL,
  REACT_APP_AUTH_COOKIE_ONLY: process.env.REACT_APP_AUTH_COOKIE_ONLY,
};

// eslint-disable-next-line import/prefer-default-export
export const env = (key) => {
  const runtimeEnv = (typeof window !== 'undefined' && window.RUNTIME_ENV) || {};
  const runtimeValue = runtimeEnv[key];

  return runtimeValue !== undefined && runtimeValue !== '' ? runtimeValue : buildTimeEnv[key];
};
